/**
 * Container registration: the Control parser. It registers no node component,
 * so the dispatcher falls back to GenericNodeFallback.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseControl } from '../../../2d/ui/control/parser';
const containerRegistration = {
    typeName: 'Container',
    parser: parseControl,
};
nodeRegistry.register(containerRegistration);
//# sourceMappingURL=index.js.map